import BitcoinWellLogo from "../assets/ExchangeLogos/bitcoin-well.png";
import NdaxLogo from "../assets/ExchangeLogos/ndax.png";
import VirgocxLogo from "../assets/ExchangeLogos/virgocx.png";
import BullBitcoinLogo from "../assets/ExchangeLogos/bull-bitcoin.png";
import KrakenProLogo from "../assets/ExchangeLogos/kraken-pro.png";
import KrakenLogo from "../assets/ExchangeLogos/kraken.png";
import NetcoinsLogo from "../assets/ExchangeLogos/netcoins.png";
import BitbuyLogo from "../assets/ExchangeLogos/bitbuy.png";
import NewtonLogo from "../assets/ExchangeLogos/newton.png";
import CoinsquareLogo from "../assets/ExchangeLogos/coinsquare.png";
import CryptoComLogo from "../assets/ExchangeLogos/crypto-com.png";
import ShakepayLogo from "../assets/ExchangeLogos/shakepay.png";
import CoinbaseProLogo from "../assets/ExchangeLogos/coinbase-pro.png";
import WealthsimpleLogo from "../assets/ExchangeLogos/wealth-simple.png";
import BeaverBitcoinLogo from "../assets/ExchangeLogos/beaver-bitcoin.png";
import BitcoinExpressLogo from "../assets/ExchangeLogos/1-bitcoin-express.png";
import ChicksxLogo from "../assets/ExchangeLogos/chicksx.png";
import CoinbaseLogo from "../assets/ExchangeLogos/coinbase.png";
import MybtcLogo from "../assets/ExchangeLogos/my-btc.png";

export const exchanges: any[] = [
  {
    id: "bitcoin-well",
    image: BitcoinWellLogo,
    name: "Bitcoin Well",
    type: "Non Custodial",
    url: "http://bitcoinwell.com/app/signup?referral=craigleo",
    depositFee: 0,
    withdrawalFee: 0,
    spreadFee: 1.2,
    networkFee: 0,
    rate: 45190,
    depositType: "Interac/Bill/Cash Vouchers",
    tradeFee: "1.2% spread (verified accounts)",
    details: "ATMs available, non-custodial",
    referralPromo: "",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 0,
            currency: "CAD",
            note: "Min: varies by account status",
          },
        ],
      },
      {
        type: "Bill Payments",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 0,
            currency: "CAD",
            note: "Min varies by biller",
          },
        ],
      },
      {
        type: "Cash Vouchers",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 0,
            currency: "CAD",
            note: "Min varies by voucher provider",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Bitcoin On-chain",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 0,
            currency: "BTC",
            note: "Min: 0.001 BTC",
          },
        ],
      },
      {
        type: "Express On-chain",
        tiers: [
          {
            feeType: "note",
            feeValue: 0,
            currency: "BTC",
            note: "Priority network fee applies",
          },
        ],
      },
      {
        type: "Lightning Network",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 0,
            currency: "BTC",
            note: "Max: 0.15 BTC",
          },
        ],
      },
      {
        type: "Liquid Network",
        tiers: [{ feeType: "percentage", feeValue: 0, currency: "BTC" }],
      },
    ],
    ratings: {
      apple: "",
      google: "",
    },
    tradingFees: {
      type: "spread",
      tiers: [
        {
          feeValueMin: 1.2,
          feeValueMax: 1.2,
          currency: "%",
          note: "Approximate spread for verified accounts",
        },
      ],
    },
  },

  {
    id: "ndax",
    image: NdaxLogo,
    name: "NDAX",
    type: "Custodial",
    url: "https://refer.ndax.io/ebgT",
    depositFee: 0,
    withdrawalFee: 0.00007,
    spreadFee: 0.2,
    networkFee: 0,
    rate: 45104,
    depositType: "Interac/Wire",
    tradeFee: "0.20% spread",
    details: "Multiple withdrawal options with varying speeds",
    referralPromo: "Get $10",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Bitcoin EXPRESS",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0.00014,
            currency: "BTC",
            note: "Instant",
          },
        ],
      },
      {
        type: "Bitcoin STANDARD",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0.00007,
            currency: "BTC",
            note: "Up to 4h",
          },
        ],
      },
      {
        type: "Bitcoin FLEX",
        tiers: [
          { feeType: "flat", feeValue: 0, currency: "BTC", note: "Up to 12h" },
        ],
      },
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 1.5, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [{ feeType: "flat", feeValue: 4.99, currency: "CAD" }],
      },
    ],
    ratings: {
      apple: "4.7/5 (8K)",
      google: "4.6/5 (2.3K)",
    },
    tradingFees: {
      type: "spread",
      tiers: [
        {
          feeValueMin: 0.2,
          feeValueMax: 0.2,
          currency: "%",
          note: "Flat spread",
        },
      ],
    },
  },

  {
    id: "virgocx",
    image: VirgocxLogo,
    name: "VirgoCX",
    type: "Non Custodial",
    url: "https://virgocx.ca/register?code=LUanuQIt",
    depositFee: 0,
    withdrawalFee: 0.0002944,
    spreadFee: 0.95,
    networkFee: 0,
    rate: 45130,
    depositType: "Interac/Wire/Bill",
    tradeFee: "0.95% spread (BTC Tier 1)",
    details: "Monthly subsidy for withdrawals",
    referralPromo: "Get $20",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          { feeType: "flat", feeValue: 0, currency: "CAD", note: "Min: $10" },
        ],
      },
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Min: $3,000",
          },
        ],
      },
      {
        type: "Bill Payment",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Crypto Withdrawal",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "First $6 covered per month",
          },
        ],
      },
    ],
    ratings: {
      apple: "4.4/5 (315)",
      google: "4.2/5 (235)",
    },
    tradingFees: {
      type: "spread",
      tiers: [
        {
          feeValueMin: 0.95,
          feeValueMax: 0.95,
          currency: "%",
          note: "BTC & ETH Tier 1",
        },
        {
          feeValueMin: 1.6,
          feeValueMax: 1.6,
          currency: "%",
          note: "Other assets Tier 2",
        },
      ],
    },
  },

  {
    id: "bull-bitcoin",
    image: BullBitcoinLogo,
    name: "Bull Bitcoin",
    type: "Non Custodial",
    url: "https://www.bullbitcoin.com/",
    depositFee: 0,
    withdrawalFee: 0,
    spreadFee: 2.5,
    networkFee: 0,
    rate: 45170,
    depositType: "Interac/Bill/Wire/Post",
    tradeFee: "~2.5% spread",
    details: "Non-custodial, auto-withdrawals to your wallet",
    referralPromo: "",
    depositMethods: [
      {
        type: "E-transfer (CAD)",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Min: 50 CAD",
          },
        ],
      },
      {
        type: "Bill payment (CAD)",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Min: 1000 CAD",
          },
        ],
      },
      {
        type: "Wire transfer (CAD)",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Min: 1000 CAD",
          },
        ],
      },
      {
        type: "Canada Post",
        tiers: [{ feeType: "flat", feeValue: 3.95, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "On-chain",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "BTC",
            note: "Min: 0.001 BTC",
          },
        ],
      },
      {
        type: "Express on-chain",
        tiers: [
          {
            feeType: "note",
            feeValue: 0,
            currency: "BTC",
            note: "Priority network fee applies",
          },
        ],
      },
      {
        type: "Lightning Network",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "BTC",
            note: "Max: 0.15 BTC",
          },
        ],
      },
      {
        type: "Liquid Network",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "BTC" }],
      },
    ],
    ratings: {
      apple: "",
      google: "",
    },
    tradingFees: {
      type: "spread",
      tiers: [
        {
          feeValueMin: 2.5,
          feeValueMax: 2.5,
          currency: "%",
          note: "Approximate spread",
        },
      ],
    },
  },

  {
    id: "kraken-pro",
    image: KrakenProLogo,
    name: "Kraken Pro",
    type: "Custodial",
    url: "https://kraken.pxf.io/jWx5QM",
    depositFee: 0.5,
    withdrawalFee: 0.00001,
    spreadFee: 0.16,
    networkFee: 0,
    rate: 45220,
    depositType: "Interac/Wire",
    tradeFee: "0-0.26% spread with 0.00001 BTC withdrawal fee",
    details: "Best for high volume traders",
    referralPromo: "",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "percentage", feeValue: 0.5, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [{ feeType: "percentage", feeValue: 0.5, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "note",
            feeValue: 0,
            currency: "CAD",
            note: "Varies by bank",
          },
        ],
      },
    ],
    ratings: {
      apple: "4.6/5 (16K)",
      google: "4.6/5 (36K)",
    },
    tradingFees: {
      type: "tiered",
      tiers: [
        {
          volumeMin: 0,
          volumeMax: 10000,
          makerFeePercent: 0.25,
          takerFeePercent: 0.4,
          note: "Volume $0+",
        },
        {
          volumeMin: 10000,
          volumeMax: 50000,
          makerFeePercent: 0.2,
          takerFeePercent: 0.35,
          note: "Volume $10,000+",
        },
        {
          volumeMin: 50000,
          volumeMax: 100000,
          makerFeePercent: 0.14,
          takerFeePercent: 0.24,
          note: "Volume $50,000+",
        },
        {
          volumeMin: 100000,
          volumeMax: 250000,
          makerFeePercent: 0.12,
          takerFeePercent: 0.22,
          note: "Volume $100,000+",
        },
        {
          volumeMin: 250000,
          makerFeePercent: 0.1,
          takerFeePercent: 0.2,
          note: "Volume $250,000+",
        },
      ],
    },
  },

  {
    id: "kraken",
    image: KrakenLogo,
    name: "Kraken",
    type: "Custodial",
    url: "https://kraken.pxf.io/jWx5QM",
    depositFee: 0.5,
    withdrawalFee: 0.00001,
    spreadFee: 0.26,
    networkFee: 0,
    rate: 45200,
    depositType: "Interac/Wire",
    tradeFee: "0.2 - 0.3% spread with 0.00001 Withdrawal fee",
    details: "Advanced Trading",
    referralPromo: "",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "percentage", feeValue: 0.5, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [{ feeType: "percentage", feeValue: 0.5, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "note",
            feeValue: 0,
            currency: "CAD",
            note: "Varies by bank",
          },
        ],
      },
    ],
    ratings: {
      apple: "4.7/5 (8.4K)",
      google: "4/5 (30.4K)",
    },
    tradingFees: {
      type: "spread",
      tiers: [
        {
          feeValueMin: 0.2,
          feeValueMax: 0.3,
          currency: "%",
          note: "Spread varies by volume",
        },
      ],
    },
  },

  {
    id: "netcoins",
    image: NetcoinsLogo,
    name: "Netcoins",
    type: "Custodial",
    url: "https://www.netcoins.com/",
    depositFee: 0,
    withdrawalFee: 0.00014,
    spreadFee: 0.5,
    networkFee: 0,
    rate: 45140,
    depositType: "Interac/Wire/Bill",
    tradeFee: "0.5% spread",
    details: "Min withdrawal: 0.00028 BTC",
    referralPromo: "",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Free for deposits over $3,000 CAD",
          },
          {
            feeType: "flat",
            feeValue: 50,
            currency: "CAD",
            note: "Withdrawals under $25,000 CAD",
          },
        ],
      },
      {
        type: "Bill Payment",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 50,
            currency: "CAD",
            note: "For withdrawals under $25,000 CAD",
          },
        ],
      },
      {
        type: "Crypto Withdrawal",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0.00014,
            currency: "BTC",
            note: "Min: 0.00028 BTC",
          },
        ],
      },
    ],
    ratings: {
      apple: "4.9/5 (75)",
      google: "4.1/5 (282)",
    },
    tradingFees: {
      type: "spread",
      tiers: [
        {
          feeValueMin: 0.5,
          feeValueMax: 0.5,
          currency: "%",
          note: "Flat spread",
        },
      ],
    },
  },

  {
    id: "bitbuy",
    image: BitbuyLogo,
    name: "Bitbuy",
    type: "Custodial",
    url: "https://app.bitbuy.ca/en/sign-up/?c=CIMG5JQZQM",
    depositFee: 0,
    withdrawalFee: 0.00025,
    spreadFee: 0.75,
    networkFee: 0,
    rate: 45160,
    depositType: "Wire/Interac",
    tradeFee: "0 - 1.5% spread with 0.00025 BTC withdrawal fee",
    details: "Pro trading available",
    referralPromo: "",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [{ feeType: "percentage", feeValue: 1.5, currency: "CAD" }],
      },
    ],
    ratings: {
      apple: "4.5/5 (6.7K)",
      google: "2.4/5 (1.8K)",
    },
    tradingFees: {
      type: "tiered",
      tiers: [
        {
          volumeMin: 0,
          note: "Express trade uses dynamic spread; exact tiers not published",
        },
        {
          volumeMin: 0,
          volumeMax: Infinity,
          makerFeePercent: 0.5,
          takerFeePercent: 0.5,
          note: "Pro trade tier",
        },
      ],
    },
  },

  {
    id: "newton",
    image: NewtonLogo,
    name: "Newton",
    type: "Custodial",
    url: "https://web.newton.co/r/YASRDJ",
    depositFee: 0,
    withdrawalFee: 0,
    spreadFee: 1.075,
    networkFee: 10,
    rate: 45180,
    depositType: "Interac/Wire/EFT",
    tradeFee: "1 - 1.15% spread",
    details: "Three withdrawal options: Fast, Standard, Free",
    referralPromo: "Get $25",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "EFT",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [
          { minAmount: 10000, feeType: "flat", feeValue: 0, currency: "CAD" },
          {
            minAmount: 5000,
            maxAmount: 10000,
            feeType: "flat",
            feeValue: 35,
            currency: "CAD",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Fast Lane",
        tiers: [
          {
            feeType: "flat",
            feeValue: 10,
            currency: "CAD",
            note: "Plus network fee; ~20 min",
          },
        ],
      },
      {
        type: "Standard Lane",
        tiers: [
          {
            feeType: "note",
            feeValue: 0,
            currency: "CAD",
            note: "Network fee only; ~2 hours",
          },
        ],
      },
      {
        type: "Free Lane",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Processed nightly",
          },
        ],
      },
    ],
    ratings: {
      apple: "4.6/5 (21.7K)",
      google: "4.5/5 (7K)",
    },
    tradingFees: {
      type: "spread",
      tiers: [
        {
          feeValueMin: 1.0,
          feeValueMax: 1.15,
          currency: "%",
          note: "Spread range",
        },
      ],
    },
  },

  {
    id: "coinsquare",
    image: CoinsquareLogo,
    name: "Coinsquare",
    type: "Custodial",
    url: "https://www.coinsquare.com/",
    depositFee: 0,
    withdrawalFee: 0,
    spreadFee: 1.5,
    networkFee: 0,
    rate: 45050,
    depositType: "Various",
    tradeFee: "1.50% spread",
    details: "Established Canadian exchange",
    referralPromo: "",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Min: $20, Max: $10,000",
          },
        ],
      },
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Min: $10,000, Max: Unlimited",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Min: $20, Max: $2,000",
          },
        ],
      },
      {
        type: "Direct Bank Deposit",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 1.5,
            currency: "CAD",
            note: "Min: $20, Max: $100,000",
          },
        ],
      },
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 1.5,
            currency: "CAD",
            note: "Min: $10,000, Max: Unlimited",
          },
        ],
      },
    ],
    ratings: {
      apple: "4.6/5 (5K)",
      google: "3.6/5 (2K)",
    },
    tradingFees: {
      type: "tiered",
      tiers: [
        {
          note: "Coinsquare Trade uses spread-based model; exact tiers not published",
        },
        {
          makerFeePercent: 0.5,
          takerFeePercent: 0.5,
          note: "Coinsquare Pro",
        },
      ],
    },
  },

  {
    id: "crypto.com",
    image: CryptoComLogo,
    name: "Crypto.com",
    type: "Custodial",
    url: "https://crypto.com/exch/howbtc101",
    depositFee: 0,
    withdrawalFee: 0.0006,
    spreadFee: 0.375,
    networkFee: 0,
    rate: 45100,
    depositType: "Interac/Bank",
    tradeFee: "Tiered maker/taker; approx. 0.25%/0.5% at Level 1",
    details: "Tiered fee structure, Visa card available",
    referralPromo: "Get $25",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Bank Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Crypto.com App",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "External Withdrawal",
        tiers: [{ feeType: "flat", feeValue: 0.0006, currency: "BTC" }],
      },
    ],
    ratings: {
      apple: "4.6/5 (46K)",
      google: "4.3/5 (497K)",
    },
    tradingFees: {
      type: "tiered",
      tiers: [
        {
          volumeMin: 0,
          volumeMax: 10000,
          makerFeePercent: 0.25,
          takerFeePercent: 0.5,
          note: "Level 1: < $10K",
        },
        {
          volumeMin: 500000,
          makerFeePercent: 0.08,
          takerFeePercent: 0.18,
          note: "Level 5: ≥ $500K",
        },
      ],
    },
  },

  {
    id: "shakepay",
    image: ShakepayLogo,
    name: "Shakepay",
    type: "Custodial",
    url: "https://shakepay.me/r/FM8INVL",
    depositFee: 0,
    withdrawalFee: 0,
    spreadFee: 1.25,
    networkFee: 0,
    rate: 45150,
    depositType: "Interac/Wire",
    tradeFee: "0.5% - 2.0% spread",
    details: "Instant funding, free withdrawals",
    referralPromo: "Get $20",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          { feeType: "flat", feeValue: 0, currency: "CAD", note: "Min: $5" },
        ],
      },
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Min: $10,000",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Wire Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
    ],
    ratings: {
      apple: "4.6/5 (20.4K)",
      google: "4.3/5 (13K)",
    },
    tradingFees: {
      type: "range",
      tiers: [
        {
          feeValueMin: 0.5,
          feeValueMax: 2.0,
          currency: "%",
          note: "Spread varies; up to additional 1.5% in adverse market conditions",
        },
      ],
    },
  },

  {
    id: "coinbase-pro",
    image: CoinbaseProLogo,
    name: "Coinbase Pro",
    type: "Custodial",
    url: "https://coinbase.com/join/HZB5VX5?src=referral-link",
    depositFee: 0,
    withdrawalFee: 0,
    spreadFee: 0.3,
    networkFee: 0,
    rate: 45150,
    depositType: "Banks",
    tradeFee: "Maker: 0.00% - 0.40%, Taker: 0.05% - 0.60%",
    details: "For advanced traders",
    referralPromo: "Get $10",
    depositMethods: [
      {
        type: "Bank Transfer",
        tiers: [
          {
            feeType: "note",
            feeValue: 0,
            currency: "CAD",
            note: "Varies by region",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Bank Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 25,
            currency: "CAD",
            note: "Standard wire fee; may vary by region",
          },
        ],
      },
    ],
    ratings: {
      apple: "",
      google: "",
    },
    tradingFees: {
      type: "tiered",
      tiers: [
        {
          makerFeePercent: 0.0,
          takerFeePercent: 0.05,
          note: "Low-volume tier",
        },
        {
          makerFeePercent: 0.4,
          takerFeePercent: 0.6,
          note: "High-volume tier",
        },
      ],
    },
  },

  {
    id: "wealthsimple",
    image: WealthsimpleLogo,
    name: "Wealthsimple",
    type: "Custodial",
    url: "https://my.wealthsimple.com/app/public/trade-referral-signup?code=MBXDAG",
    depositFee: 0,
    withdrawalFee: 0,
    spreadFee: 1.17,
    networkFee: 0,
    rate: 45160,
    depositType: "Interac/Banks",
    tradeFee: "Core: 2%, Premium: 1%, Generation: 0.5%",
    details: "Stocks and crypto in one platform",
    referralPromo: "Get $25",
    depositMethods: [
      {
        type: "Bank Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
      {
        type: "Interac e-Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Bank Transfer",
        tiers: [{ feeType: "flat", feeValue: 0, currency: "CAD" }],
      },
    ],
    ratings: {
      apple: "4.6/5 (125K)",
      google: "4.5/5 (79K)",
    },
    tradingFees: {
      type: "tiered",
      tiers: [
        {
          clientLevel: "Core",
          feeValueMin: 2.0,
          feeValueMax: 2.0,
          currency: "%",
          note: "Core clients",
        },
        {
          clientLevel: "Premium",
          feeValueMin: 1.0,
          feeValueMax: 1.0,
          currency: "%",
          note: "Premium clients",
        },
        {
          clientLevel: "Generation",
          feeValueMin: 0.5,
          feeValueMax: 0.5,
          currency: "%",
          note: "Generation clients",
        },
      ],
    },
  },

  {
    id: "beaver-bitcoin",
    image: BeaverBitcoinLogo,
    name: "Beaver Bitcoin",
    type: "Non Custodial",
    url: "https://www.beaverbitcoin.com/",
    depositFee: 1.5,
    withdrawalFee: 0,
    spreadFee: 0,
    networkFee: 0,
    rate: 45150,
    depositType: "Various",
    tradeFee: "1.50% flat fee",
    details: "Canadian focused",
    referralPromo: "",
    depositMethods: [
      {
        type: "Various",
        tiers: [{ feeType: "percentage", feeValue: 1.5, currency: "%" }],
      },
    ],
    withdrawalMethods: [
      {
        type: "Various",
        tiers: [
          {
            feeType: "note",
            feeValue: 0,
            currency: "CAD",
            note: "Varies by method",
          },
        ],
      },
    ],
    ratings: {
      apple: "",
      google: "",
    },
    tradingFees: {
      type: "spread",
      tiers: [
        {
          feeValueMin: 1.5,
          feeValueMax: 1.5,
          currency: "%",
          note: "Flat transparent fee covering all aspects",
        },
      ],
    },
  },

  {
    id: "1bitcoin-express",
    image: BitcoinExpressLogo,
    name: "1Bitcoin Express",
    type: "Non Custodial",
    url: "https://1bitcoin.ca/",
    depositFee: 0,
    withdrawalFee: 5,
    spreadFee: 1.2,
    networkFee: 0,
    rate: 45100,
    depositType: "Various",
    tradeFee: "0.49% - 3.49% spread",
    details: "Simple buying process",
    referralPromo: "",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 0,
            currency: "CAD",
            note: "Max: $10,000 CAD",
          },
        ],
      },
      {
        type: "Wire Transfer",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 1.0,
            currency: "CAD",
            note: "1% or $250 (Min: $10,000)",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 5,
            currency: "CAD",
            note: "Min: $20, Max: $25,000 daily",
          },
        ],
      },
    ],
    ratings: {
      apple: "",
      google: "",
    },
    tradingFees: {
      type: "range",
      tiers: [
        {
          feeValueMin: 0.49,
          feeValueMax: 3.49,
          currency: "%",
          note: "Spread varies by market conditions",
        },
      ],
    },
  },

  {
    id: "chicksx",
    image: ChicksxLogo,
    name: "ChicksX",
    type: "Non Custodial",
    url: "https://chicksx.com/",
    depositFee: 0,
    withdrawalFee: 0.5,
    spreadFee: 1.0,
    networkFee: 0,
    rate: 45050,
    depositType: "Various",
    tradeFee: "0.1% - 0.6% spread",
    details: "Newer exchange",
    referralPromo: "",
    depositMethods: [
      {
        type: "Various",
        tiers: [
          {
            feeType: "note",
            feeValue: 0,
            currency: "CAD",
            note: "Varies; not clearly specified",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Crypto Withdrawal",
        tiers: [{ feeType: "percentage", feeValue: 0.5, currency: "BTC" }],
      },
    ],
    ratings: {
      apple: "",
      google: "",
    },
    tradingFees: {
      type: "range",
      tiers: [
        {
          feeValueMin: 0.1,
          feeValueMax: 0.6,
          currency: "%",
          note: "Based on industry-standard range",
        },
      ],
    },
  },

  {
    id: "coinbase",
    image: CoinbaseLogo,
    name: "Coinbase",
    type: "Custodial",
    url: "https://coinbase.com/join/HZB5VX5?src=referral-link",
    depositFee: 1.49,
    withdrawalFee: 1.49,
    spreadFee: 0.5,
    networkFee: 0,
    rate: 45100,
    depositType: "Various",
    tradeFee:
      "0.05% - 0.60% taker, 0.00% - 0.40% maker (varies by volume), CAD1.49 Withdrawal",
    details: "Higher fees, wider availability",
    referralPromo: "Get $10",
    depositMethods: [
      {
        type: "Bank Transfer",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 1.49,
            currency: "CAD",
            note: "Varies by payment method up to 3.99%",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Bank Transfer",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 1.49,
            currency: "CAD",
            note: "Varies by withdrawal method up to 3.99%",
          },
        ],
      },
    ],
    ratings: {
      apple: "4.7/5 (1.7M)",
      google: "4.6/5 (854K)",
    },
    tradingFees: {
      type: "tiered",
      tiers: [
        {
          makerFeePercent: 0.0,
          takerFeePercent: 0.05,
          note: "Low-volume",
        },
        {
          makerFeePercent: 0.4,
          takerFeePercent: 0.6,
          note: "High-volume",
        },
      ],
    },
  },

  {
    id: "mybtc-ca",
    image: MybtcLogo,
    name: "MyBTC.ca",
    type: "Non Custodial",
    url: "https://mybtc.ca?ref=5ELBA2RxvWv61lwgyoGQ",
    depositFee: 5.85,
    withdrawalFee: 10,
    spreadFee: 4.95,
    networkFee: 0,
    rate: 44900,
    depositType: "Multiple methods",
    tradeFee: "3.95% - 7.75% depending on method",
    details: "Multiple payment options",
    referralPromo: "Get $15",
    depositMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 7.75,
            currency: "%",
            note: "Min: $10.00",
          },
        ],
      },
      {
        type: "Bill Payment",
        tiers: [{ feeType: "percentage", feeValue: 3.95, currency: "%" }],
      },
      {
        type: "Bank Wire",
        tiers: [{ feeType: "percentage", feeValue: 4.75, currency: "%" }],
      },
      {
        type: "Credit/Debit Card",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 9.75,
            currency: "%",
            note: "Min: varies",
          },
        ],
      },
      {
        type: "Flexepin Voucher",
        tiers: [
          {
            feeType: "percentage",
            feeValue: 9.75,
            currency: "%",
            note: "Min: $5.00",
          },
        ],
      },
    ],
    withdrawalMethods: [
      {
        type: "Interac e-Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 5,
            currency: "CAD",
            note: "For $20 - $10,000",
          },
        ],
      },
      {
        type: "Bank Transfer",
        tiers: [
          {
            feeType: "flat",
            feeValue: 10,
            currency: "CAD",
            note: "For $20,000 - $100,000",
          },
        ],
      },
    ],
    ratings: {
      apple: "4.8/5 (20)",
      google: "",
    },
    tradingFees: {
      type: "range",
      tiers: [
        {
          feeValueMin: 3.95,
          feeValueMax: 7.75,
          currency: "%",
          note: "Varies by payment method",
        },
      ],
    },
  },
];
